// extracted by mini-css-extract-plugin
export default {"container":"SearchResult_container__64oJj","closeBtn":"SearchResult_closeBtn__0lSdc","noresult":"SearchResult_noresult__U-DVm","backTxt":"SearchResult_backTxt__hpp2K"};